export default async function ({ redirect, app, $session, store }) {
  if ($session.user.profile === 'PRO' && !$session.user.subprofile) return true
  if ($session.user.profile === 'MICRO' && !$session.user.subprofile) return true
  if ($session.user.profile === 'FULL' && !$session.user.subprofile) return true

  const path = app.context.route.path.replace(/\/+$/, '')
  const roles = store.state.admin.roleStore.list
  const checkRoles = $session?.user?.roles?.filter(role => role.check) || []

  // si el rol es nuevo, lo deja pasar a configuracion
  if (!checkRoles.length && !roles.length && path === '/admin/datosatv') return true

  if (/*!checkRoles.length &&*/ $session.user.profile === 'COMMUNITY' || $session.user.profile === 'FACTURA') {
    if (
      path === '/admin/datosatv' ||
      path === '/facturacion/facturar' ||
      path === '/facturacion/listaFactura' ||
      path === '/facturacion/listaTiquete' ||
      path === '/facturacion/listaNotaCredito' ||
      path === '/facturacion/listaFacturaExportacion' ||
      path === '/facturacion/listaMensajeReceptor' ||
      path === '/facturacion/mensajeReceptor' ||
      path === '/facturacion/proforma' ||
      path === '/facturacion/listaFacturaOtro' ||
      path === '/facturacion/facturar/' ||
      path === '/facturacion/listaFactura/' ||
      path === '/facturacion/listaTiquete/' ||
      path === '/facturacion/listaNotaCredito/' ||
      path === '/facturacion/listaFacturaExportacion/' ||
      path === '/facturacion/listaMensajeReceptor/' ||
      path === '/facturacion/mensajeReceptor/' ||
      path === '/facturacion/proforma/' ||
      path === '/facturacion/listaFacturaOtro/' ||
      path === '/clientes/lista'
    )
      return true

    redirect('/noauth')
    return false
  }

  const openPath = path.includes('open')
  if (openPath) return true

  const hasRole = roles.reduce(
    (acc, role) =>
      checkRoles.some(r => role._id === r._id)
        ? (acc = role.events.reduce(
            (y, event) => (event.group.some(group => group.check && group.path.toUpperCase() === path.toUpperCase()) ? (y = true) : y),
            acc
          ))
        : acc,
    false
  )

  if (!hasRole) {
    console.log('No tiene permisos para ver esta página, Qué está tratando de hacer??? 🤨')
    redirect('/noauth')
    return false
  }
  return true
}
